import React from 'react';
export const Typography = () => {
    return React.createElement("div", null);
};
